// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"Main_thecomp__6VAZh"};